import { Controller } from '@hotwired/stimulus';

export default class DebouncedSubmitController extends Controller<HTMLFormElement> {
  public static readonly targets = ['submitButton'];

  public static readonly values = {
    delay: { type: Number, default: 300 },
    submitOnConnect: { type: Boolean, default: false }
  };

  declare public readonly submitButtonTarget: HTMLButtonElement;

  declare private readonly delayValue: number;
  declare private readonly submitOnConnectValue: boolean;

  private debounceTimer: number | undefined;

  public connect(): void {
    if (this.submitOnConnectValue) {
      this.schedule();
    }
  }

  public disconnect(): void {
    window.clearTimeout(this.debounceTimer);
  }

  public schedule(): void {
    window.clearTimeout(this.debounceTimer);
    this.debounceTimer = window.setTimeout(() => {
      this.element.requestSubmit(this.submitButtonTarget);
    }, this.delayValue);
  }
}
